$(document).ready(function () {
    const slickOptions = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: true,
        pauseOnFocus: false,
        arrows: true,
        prevArrow: $('.slick-carousel__arrow--prev'),
        nextArrow: $('.slick-carousel__arrow--next'),
        andInit: function (e, slick) {
        },
    };

    $(".js-home-slider").CreateSlickSlider(
        slickOptions
    );
});
